import { handleActions } from 'redux-actions';

const reducer = handleActions({}, {});

export default reducer;
